<template>
  <div class="pdeliverorderApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="tab">
      <a @click="tab(3)" :class="state == 3 ? 'curt' : ''">接单</a>
      <a @click="tab(1)" :class="state == 1 ? 'curt' : ''">已接单</a>
      <a @click="tab(2)" :class="state == 2 ? 'curt' : ''">已完成</a>
    </div>
    <div style="height:46px"></div>
    <div class="executeTotal">
      <div class="item" :style="'background:url('+require('../../assets/img3/a35.png')+');background-size:cover'">
        <div class="num">已完成{{setTotalExpress.total}}单</div>
      </div>
      <div class="item" :style="'background:url('+require('../../assets/img3/a34.png')+');background-size:cover'">
        <div class="num">收入{{setTotalExpress.draw}}元</div>
      </div>
    </div>
    <div class="executeList" v-for="(item,i) in setExpress">
      <div class="timers">
        订单编号  {{item.number}}
      </div>
      <div class="conlist">
        <h1>{{item.title}}订单</h1>
        <div class="price">
          <div class="s1"><img src="~assets/img3/a8.png" />订单价格<font>{{item.price}}</font>元</div>
          <div class="s1"><img src="~assets/img3/a9.png" />提成<font>{{item.divide}}</font>元</div>
        </div>
        <div class="bottom">
          <span>下单时间：{{item.createtime}}</span>
          <span>联系人：{{item.name}}</span>
          <span>联系电话：{{item.phone}}</span>
          <span>配送地址：{{item.address}}</span>
          <span>订单备注：{{item.remark == null ? '无' : item.remark}}</span>
        </div>
        <div class="btn">
          <div class="b1" @click="goDeliver(item.id)"><img src="~assets/img3/a52.png" />订单详情</div>
          <!--<div class="b1"><img src="~assets/img3/a51.png" />结算清单</div>-->
        </div>
      </div>
    </div>

    <div class="none" v-if="setExpress.length<=0"><img src="~assets/img3/none.png" />暂无数据信息</div>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setExpress:[],
        state:1,
        setTotalExpress:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/pdeliverorder?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      this.getExpress()
      this.getTotal();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      goDeliver:function(id){
        this.$router.push({
          path:'pdeliverdetail',
          query:{
            id:id
          }
        })
      },
      tab:function(inx){
        this.state = inx;
        this.getExpress()
      },
      getExpress:function(){
        var that = this;
        that.fullscreenLoading = true
        var mall_id = this.$route.query.id;
        var uid = this.$route.query.uid;
        $.ajax({
          type:'post',
          url:that.$host+'home/product/userExpress',
          data:{
            mall_id:mall_id,
            user_id:uid,
            state:that.state
          },
          dataType:'json',
          success:function(data){
            that.setExpress = data.data;
            that.fullscreenLoading = false
          }
        })
      },

      getTotal:function(){
        var that = this;
        that.fullscreenLoading = true
        var mall_id = this.$route.query.id;
        var uid = this.$route.query.uid;
        $.ajax({
          type:'post',
          url:that.$host+'home/product/totalExpress',
          data:{
            mall_id:mall_id,
            user_id:uid
          },
          dataType:'json',
          success:function(data){
            that.setTotalExpress = data.data;
            that.fullscreenLoading = false
          }
        })
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .pdeliverorderApp{
    max-width:640px;
    background:#ebebeb;
    margin:0 auto;
  }
  .pdeliverorderApp .tab{
    width:100%;
    height:45px;
    top:0;
    left:0;
    background:#fff;
    position:fixed;
  }
  .pdeliverorderApp .tab a{
    float:left;
    width:75px;
    height:35px;
    background: #F1F2F5;
    text-align:center;
    line-height:35px;
    margin:5px 0 0 3%;
    border-radius:5px;
    font-size:15px;
    color: #3C485C;
  }
  .pdeliverorderApp .tab a.curt{
    color: #0059D6;
  }

  .pdeliverorderApp .executeTotal{
    background:#fff;
    width:94%;
    height: 88px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    padding:0 3%;
    margin:0 0 12px 0
  }
  .pdeliverorderApp .executeTotal .item{
    width:48.5%;
    height: 65px;
    background: #F6FCFB;
    border-radius: 8px;
    margin-top:11.5px;
    color: #fff;
    font-size: 18px;
    line-height: 65px;
  }
  .pdeliverorderApp .executeTotal .item div{
    padding-left:15px
  }

  .pdeliverorderApp .executeList{
    width:94%;
    margin:0 auto 2px auto;
  }
  .pdeliverorderApp .executeList .timers{
    font-size:14px;
    padding:10px 4% 20px 4%;
    color: #fff;
    background: linear-gradient( 90deg, #649DFF 0%, #6F9FFF 100%);
    border-radius: 12px 12px 0 0;
  }
  .pdeliverorderApp .executeList .timers img{
    width:16px;
    height:16px;
    margin-right:3px;
    vertical-align:top;
    margin-top:2px
  }
  .pdeliverorderApp .executeList .timers .edit{
    float:right;
    margin-left:15px;
    cursor: pointer;
  }
  .pdeliverorderApp .executeList .timers .edit:hover{
    font-weight:bold;
  }
  .pdeliverorderApp .executeList .timers .edit em{
    font-size:18px;
    float:left;
    margin-right:2px
  }
  .pdeliverorderApp .executeList .conlist{
    background: #FFFFFF;
    border-radius: 12px;
    width:100%;
    position: relative;
    top:-10px
  }
  .pdeliverorderApp .executeList .conlist h1{
    font-weight: bold;
    font-size: 18px;
    color: #091D3A;
    padding:12px 4%;
    text-align: justify;
    word-break: break-all;
  }
  .pdeliverorderApp .executeList .conlist .price{
    height: 36px;
    background: linear-gradient( 270deg, #FFFFFF 0%, #FEF2F3 100%);
    width:92%;
    margin:0 auto 20px auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  .pdeliverorderApp .executeList .conlist .price div{
    width:50%;
    line-height: 36px;
    color: #4B5B76;
    font-size: 14px;
    border-radius: 6px 6px 6px 6px;
  }
  .pdeliverorderApp .executeList .conlist .price div font{
    color:#E34D59;
    font-weight:bold
  }
  .pdeliverorderApp .executeList .conlist .price div:last-child font{
    color:#D76B37
  }
  .pdeliverorderApp .executeList .conlist .price div img{
    float:left;
    width:24px;
    height:24px;
    margin:6px 0px 0 5px
  }
  .pdeliverorderApp .executeList .conlist .bottom{
    width:92%;
    margin:0 auto;
  }
  .pdeliverorderApp .executeList .conlist .bottom span{
    display:block;
    font-size: 12px;
    color: #4B5B76;
    padding-bottom:15px
  }
  .pdeliverorderApp .executeList .conlist .btn{
    width:100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    height:44px;
    border-top:solid 1px #EBEDF1
  }
  .pdeliverorderApp .executeList .conlist .btn .b1{
    width:100%;
    text-align:center;
    line-height:44px;
    font-size: 14px;
    color: #0059D6;
    cursor: pointer;
  }
  .pdeliverorderApp .executeList .conlist .btn .b1:hover{
    font-weight:bold
  }
  .pdeliverorderApp .executeList .conlist .btn .b1:last-child{
    border-left:solid 1px #EBEDF1
  }
  .pdeliverorderApp .executeList .conlist .btn .b1 img{
    width:16px;
    height:16px;
    vertical-align: top;
    margin:14px 4px 0 0
  }

  .pdeliverorderApp .none{
    text-align:center;
    line-height:55px;
    color: #5F7292;
    font-size: 16px;
    padding-top:30%
  }
  .pdeliverorderApp .none img{
    width:48px;
    height:48px;
    vertical-align:top;
    margin-right:8px
  }
  
</style>